export enum SimphonyCheckHandling {
  PULL = 'pull',
  PUSH = 'push',
}
